
import { mergeMap } from 'rxjs/operators';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild
} from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser'

import {
  Router,
  ActivatedRoute
} from '@angular/router';

import { FileService } from '../../services/file.service';
import { NotificationService } from '../../services/notification.service';
import { MessageService } from '../../services/message.service';
import { TranslateService } from '@ngx-translate/core';
import { FileTableService } from "../../services/filetable.service";

import * as _ from 'lodash';

@Component({
  selector: 'contractor-upload',
  templateUrl: './contractor-upload.component.html',
  styleUrls: ['./contractor-upload.component.scss']
})
export class ContractorUploadComponent implements OnInit, OnDestroy {
  error = null;
  file = null;
  initialFile = null;
  putToken = null;
  filesToUpload = [];
  filesToPreview = [];

  fileId = '';
  versionId = null;
  success = null;
  messages = [];
  linkedfiles = [];
  requestedfiles = [];
  filesUploaded = [];
  table = {
    requestedfiles: { all: [], display: [] },
    pending: { all: [], display: [] },
    linkedfiles: { all: [], display: [] }
  }
  mailToken = null;
  initialMailToken = null;
  openMessages = false;
  working = false;
  fileViewUrls = [];
  tabindex = 0;
  selectedRowUploads: null;
  selectedRowLinkedFiles: null;
  pid: null;
  isPhone = true;
  lastLocation = null;

  private _sub;

  stringify(data) {
    return JSON.stringify(data);
  }

  @ViewChild('fileTable') fileTable;
  @ViewChild('sharedFileTable') sharedFileTable;


  constructor(private _router: Router, private _route: ActivatedRoute, private _fileService: FileService, private _notification: NotificationService,
    private _sanitizer: DomSanitizer, public translate: TranslateService, private _messageService: MessageService, private _filetable: FileTableService) {

  }

  _reset() {
    this.error = null;
    this.success = null;
    this.file = null;
    this.putToken = null;
    this.filesToUpload = [];
    this.fileId = '';
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  getStatus = (row) => this._filetable.getStatus(row, this.pid || this.file.PID._id);
  status2imgfn = (status) => this._filetable.status2imgfn(status);
  room2imgfn = (room) => this._filetable.room2imgfn(room);
  contractorClass = (row) => this._filetable.contractorClass(row);
  formatContractor = (row) => this._filetable.formatContractor(row);

  filterOnOff() {
    this.fileTable.showfilters = this.fileTable.showfilters ? false : true;
  }

  selectRowUploads(obj, idx) {
    this.selectedRowUploads = idx;
  }

  selectRowLinkedFiles(obj, idx) {
    this.selectedRowLinkedFiles = idx;
  }

  getRequestedFile(f) {
    return f && this.requestedfiles.filter(x => x._id == f._id)[0];
  }

  onTabChanged(event) {
    this.success = false;
    this.filesUploaded = [];
    let previousIndex = this.tabindex;
    //console.log("tab changed", event, previousIndex, this.lastLocation);
    this.tabindex = event.index;
    let targetfile = this.getRequestedFile(this.lastLocation);

    if (previousIndex == 2 && targetfile) {
      //console.log("go to upload from tab changed");
      this.goToUpload(this.file);
    }
  }

  getHeight() {
    if (this.isPhone) return 92;
    return 66;
  }

  getHeaderHeight() {
    if (this.isPhone) return 0;
    return 50;
  }

  getWidth(x) {
    if (this.isPhone) {
      return 287;
    }
    return 185;
  }

  updateContractorFiles = () => {
    //console.log("update contractor files", this.initialFile, this.file, this.initialMailToken, "uploaded", uploaded)

    this._fileService.getContractorFiles(this.initialFile, this.initialMailToken).subscribe(
      (infofiles: any) => {

        //console.log("requested files", infofiles.files);
        this.requestedfiles = infofiles.files;
        this.linkedfiles = infofiles.linkedfiles;

        this.table.linkedfiles.all = this.linkedfiles.map(x => {
          x.PID = x.file.PID;
          x.name = x.file.name;
          x.type = x.file.type;
          x.job = x.file.job;
          x.description = x.file.description;
          x.deadline = x.file.deadline;
          return x;
        });
        this.table.linkedfiles.display = this.linkedfiles;
        this.table.requestedfiles.all = this.requestedfiles;
        this.table.requestedfiles.display = this.requestedfiles;

        if (this.fileTable) {
          // init already called on fileTable, we need to update file status
          this.fileTable.updateData();
        }

        if (this.lastLocation && this.tabindex == 2) {
          var targetfile = this.getRequestedFile(this.lastLocation);
          //console.log("last location", this.lastLocation, targetfile);

          if (this.lastLocation.sharingType == 'distinct') {
            // make sure we point to the correct subpid (file sharing distinct)
            targetfile.PID = this.lastLocation.PID;
          }
          this.working = false;
          //console.log("go to upload from update contractor files");
          this.goToUpload(targetfile);
        }

      },
      err => {
      }
    );
  }

  ngOnInit() {
    this.isPhone = window.matchMedia('(max-width: 767px)').matches;
    //console.log("contractor is phone", this.isPhone);
    //noinspection TypeScriptValidateTypes
    this._sub = this._route.params.pipe(
      mergeMap((params: any) => {
        this.fileId = params['id'];
        this.mailToken = params['token'];
        this.pid = params['pid'];

        return this._fileService.getPutToken(params['token'], params['id']);
      }))
      .subscribe(
        (putToken: any) => {
          if (!putToken) {
            this.error = "MESSAGE.ERROR.FILE_NOT_FOUND";
          } else {
            this.putToken = putToken;
            this._fileService.getPublicInformation(this.fileId, this.pid).subscribe(
              (file: any) => {
                this.file = file;
                //console.log("have file", file, file.version);
                this.initialFile = file;
                this.initialMailToken = this.mailToken;
                //console.log('get public information', file);
                this.fileViewUrls = [];
                this.translate.use(file.PID.PIDOwner.lang);
                document.documentElement.setAttribute("lang", file.PID.PIDOwner.lang);
                //console.log("public information", file.sharingType, file);

                this._fileService.getContractorFileURL(this.file.PID._id, this.file, putToken)
                  .subscribe(
                    (ret: any) => {
                      if (ret.version) {
                        //console.log("getContractorFileURL ret", ret);

                        this.fileViewUrls = _.map(ret.version.files, (f, i) => {
                          let r = {
                            type: f['fileType'],
                            name: f['name'],
                            url: ret.urls[i],
                            getUrl: this._sanitizer.bypassSecurityTrustResourceUrl(ret.urls[i]),
                            downloadUrl: this._sanitizer.bypassSecurityTrustUrl(ret.urls[i])
                          };
                          //console.log(r);
                          return r;
                        });

                        //this.file['version'] = ret.version;
                        this.versionId = ret.version._id;

                        //console.log("version", ret.version, this.versionId, this.fileViewUrls);
                      }
                    },
                    err => {
                      this.error = "MESSAGE.ERROR.FILE_NOT_FOUND";
                      this._notification.errorServer(err);
                    });

                this.updateContractorFiles();

                this._messageService.getContractorFileMessages(this.fileId, this.mailToken).subscribe(
                  (messages: any) => {
                    this.messages = _.map(messages, m => {
                      return this._setMessageDisplayInfo(m);
                    });
                    if (this.messages.length > 0) {
                      this.openMessages = true;
                    }
                  },
                  err => {
                  }
                )
              },
              err => this.error = "MESSAGE.ERROR.FILE_NOT_FOUND"
            )
          }
        },
        err => this.error = "MESSAGE.ERROR.FILE_NOT_FOUND"
      );
  }

  fileChangeEvent(fileInput) {
    //console.log("fileChangeevent");
    //this.filesToUpload = fileInput.target.files;
    for (let f of fileInput.target.files) {
      this.filesToUpload.push({ upload: true, file: f });
    }
    this._preview();
  }

  private _preview() {
    //console.log("_preview", this.filesToUpload);
    var filesToPreview_tmp = [];

    _.forEach(this.filesToUpload, (x, i) => {
      var reader = new FileReader();
      var _self = this;

      if (x.upload) {
        reader.addEventListener("load", function () {
          x.file.data = _self._sanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
          filesToPreview_tmp.push(x.file);
          if (filesToPreview_tmp.length == _self.filesToUpload.filter(x => x.upload).length) {
            _self.filesToPreview = filesToPreview_tmp;
          }
        }, false);
        reader.readAsDataURL(x.file);
      }
    });
  }

  dragover(elem) {
    elem.classList.add('hover');
    return false;
  }

  dragend(elem) {
    elem.classList.remove('hover');
    return false;
  }

  drop($e, elem) {
    elem.classList.remove('hover');
    $e.preventDefault();
    $e.stopPropagation();

    //this.filesToUpload = $e.dataTransfer.files;
    for (let f of $e.dataTransfer.files) {
      this.filesToUpload.push({ upload: true, file: f });
    }
    this._preview();
  }

  getDownloadUrl(url) {
    return this._sanitizer.bypassSecurityTrustUrl(url);
  }

  goToUpload = (f, version = null) => {
    //console.log("go to upload");

    this.lastLocation = f;
    //console.log("go to upload", f._id, f.PID._id, f.sharingType, f, version);
    var parent = this;
    this.fileViewUrls = [];
    this._fileService.getPublicInformation(f._id, f.PID._id).subscribe(
      (file: any) => {
        this.file = file;
        this.fileId = f._id;
        this.mailToken = f.hmac || this.mailToken;
        this.pid = f.PID._id;
        this.filesToPreview = [];

        //console.log("goToUpload: setting pid / parent PID", this.pid, f.PID.parentPID);
        this.file.PID.parentPID = f.PID.parentPID; // more detailed information is available in f
        this.translate.use(file.PID.PIDOwner.lang);
        document.documentElement.setAttribute("lang", file.PID.PIDOwner.lang);
        //console.log("pi", this.file);

        //console.log("args", f.PID._id, f._id, f.hmac, this.mailToken);

        this._fileService.getPutToken(this.mailToken, f._id).subscribe(
          putToken => {
            //console.log("put token", putToken);
            this.putToken = putToken;
            this.fileViewUrls = [];

            this._fileService.getContractorFileURL(f.PID._id, f, putToken, version)
              .subscribe(
                (ret: any) => {
                  //console.log("contracto file url", ret);
                  if (ret.version) {
                    //console.log("ret", ret.version, ret.version.files);

                    this.fileViewUrls = _.map(ret.version.files, (f, i) => {
                      return {
                        type: f['fileType'],
                        name: f['name'],
                        originalGetUrl: ret.urls[i],
                        url: ret.urls[i],
                        getUrl: this._sanitizer.bypassSecurityTrustResourceUrl(ret.urls[i]),
                        downloadUrl: this._sanitizer.bypassSecurityTrustUrl(ret.urls[i])
                      }
                    });

                    this.file['versions'] = file.version;
                    this.file.versions = this._fileService.displayVersionsOnly(this.file.versions);
                    if (f.sharingType == 'distinct') {
                      this.file.versions = this.file.versions.filter(x => x.PID == f.PID._id);
                    }
                    this.versionId = ret.version._id;
                    this.file.hmac = this.mailToken;
                  }
                  parent.tabindex = 2;

                },
                err => {
                  this.error = "MESSAGE.ERROR.FILE_NOT_FOUND";
                  this._notification.errorServer(err);
                });
          });

      },
      err => this.error = "MESSAGE.ERROR.FILE_NOT_FOUND"
    )

  }

  goToLinkedFile = (f) => {
    //console.log("go to linked file", f);
    this.putToken = null;
    this.lastLocation = f;
    this._fileService.getPublicInformation(f.file._id).subscribe(
      (file: any) => {
        this.file = file;
        this.translate.use(file.PID.PIDOwner.lang);
        document.documentElement.setAttribute("lang", file.PID.PIDOwner.lang);
        this._fileService.getViewFileURL(this.file.PID._id, this.file, f.token)
          .subscribe(
            (ret: any) => {
              this.linkedfiles = ret.linkedfiles;

              if (ret.version) {
                this.file['version'] = ret.version;
                this.fileViewUrls = _.map(ret.version.files, (f, i) => {
                  return {
                    type: f['fileType'],
                    name: f['name'],
                    url: ret.urls[i],
                    getUrl: this._sanitizer.bypassSecurityTrustResourceUrl(ret.urls[i]),
                    downloadUrl: this._sanitizer.bypassSecurityTrustUrl(ret.urls[i])
                  }
                });
              }
            },
            err => {
              this.error = "MESSAGE.ERROR.FILE_NOT_FOUND";
              this._notification.errorServer(err);
            });

      },
      err => this.error = "MESSAGE.ERROR.FILE_NOT_FOUND"
    )
    //this._router.navigate(['contractor-upload', f.file._id, f.token, f.file.PID._id]);
    //console.log("navigate to tab 2");
    this.tabindex = 2;

  }


  uploadFile() {
    var done = 0;
    var _self = this;

    if (!this.filesToUpload || this.filesToUpload.length < 1) {
      this._notification.errorCustom('File upload', 'MESSAGE.ERROR.FILE_NOT_FOUND');
      return;
    }
    this.working = true;
    //console.log("upload file start", this.putToken, this.fileId, this.pid);

    var uploadedId = this.fileId;
    let filesToUpload = this.filesToUpload.filter(x => x.upload).map(x => {return ({'name' : x.file.name, 'type' : x.file.type})});
    this._fileService.getPutUrl(this.putToken, this.fileId, filesToUpload, this.pid)
      .subscribe(
        (urls: any) => {
          var files = this.filesToUpload.filter(x => x.upload).map((x, i) => {
            return { file: x.file, putUrl: urls[i], url: urls[i], name: x.file.name, upload: x.upload }
          });
          //console.log("upload file puturl", files);
          _.forEach(files, file => {
            //console.log("upload file start", file.putUrl, file.file, this.fileId);
            this._fileService.uploadTo(file.putUrl, file.file, this.fileId, false)
              .finally(() => {
                //console.log("upload file upload");
                ++done;
                if (done == files.length) {
                  //console.log("upload file convert");
                  this._fileService.convertToPDF(this.fileId).subscribe();
                  this._reset();
                  this.success = true;
                  this.filesUploaded = files;
                  this.file = this.initialFile;
                  //console.log("upload file", uploadedId, this.pid);
                  this.fileViewUrls = [];
                  //console.log("ngoninit");
                  /*this.updateContractorFiles(true, {file: uploadedId, pid: this.pid});
                  this.tabindex = 0;*/
                  this.ngOnInit();
                }
              })
              .subscribe(
                success => {
                },
                err => {
                  console.log("ERROR", err);
                  this._notification.errorCustom('File upload', 'Error');
                }
              )
          });
        },
        err => {

        })
  }

  private _setMessageDisplayInfo(message) {
    //console.log("set message for duspla");
    var date = new Date(message.updatedAt);
    message.content = message.content.split('\n').join('<br>');
    message.author = (message.from == this.file.PID.PIDOwner.email) ? this.file.PID.PIDOwner.name : 'DATA.YOU';
    message.side = (message.from == this.file.PID.PIDOwner.email) ? 'left' : 'right';
    message.updatedAt = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
    return message;
  }

  getMessagePadding() {
    return this.openMessages ? '24px 24px 0 24px' : '0px';
  }

  getMessageWidth() {
    return this.openMessages ? '350px' : '100%';
  }

  sendMessage(content) {
    this._messageService.addContractorMessage(this.fileId, this.mailToken, content)
      .subscribe(message => {
        this.messages.push(this._setMessageDisplayInfo(message));
      });
  }
}
